import * as React from 'react';
import { usePatchPartialPayload } from 'owa-timestream-asset-sdk';
import {
    markTodoComplete,
    markTodoIncomplete,
    spacesTodoActionTelemetryData,
} from 'owa-timestream-asset-sdk-tasks';
import { toggleTaskCompletion } from '../actions';
import type { TaskViewPayload, TaskViewCompletionProps } from '../schema';

export default function useTaskViewCompletionState({
    taskId,
    taskSubject,
    isComplete,
}: TaskViewCompletionProps) {
    const patchPartialPayload = usePatchPartialPayload<TaskViewPayload>();
    const toggleComplete = React.useCallback(() => {
        if (taskSubject) {
            toggleTaskCompletion(taskId, !isComplete);
            isComplete
                ? markTodoIncomplete(taskId, spacesTodoActionTelemetryData)
                : markTodoComplete(taskId, spacesTodoActionTelemetryData);
            patchPartialPayload({ isComplete: !isComplete });
        }
    }, [taskId, taskSubject, isComplete]);

    return {
        isComplete: isComplete,
        onToggleComplete: toggleComplete,
    };
}
